import { useModalDocumentsModel } from './modal-documents.model'
import type { ModalDocumentsProps } from './modal-documents.types'
import { ModalDocumentsView } from './modal-documents.view'

export const ModalDocuments = (props: ModalDocumentsProps) => {
  const modalDocumentsModel = useModalDocumentsModel({ isOpen: props.isOpen })

  return <ModalDocumentsView {...props} {...modalDocumentsModel} />
}
